$('html').removeClass('no-js');

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

$(function () {
    /* global Modernizr:true */

    var _this = this,
        _body = $('body');

    $('#cloudlink-chat-overlay-iframe html').ready(function() {
        console.log('chat is ready?');
    });

    $('.cb_chatbutton').click(function() {

        $('#cloudlink-chat-overlay-contact-us-button').trigger('click');
        //$('#cloudlink-chat-overlay-contact-us-button').toggle();
        //$('#cloudlink-chat-overlay-close-button').toggle();
        //$('#cloudlink-chat-overlay-iframe').toggle();
        //$('#cloudlink-chat-overlay-iframe').trigger('click');
    });

    setTimeout(function(){
        $('#cloudlink-chat-overlay-contact-us-button').trigger('click');
    }, 20000);


    /**********************
     *
     * Form Progress bar
     *
     */
    $('#msform input').keydown(function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            return false;
        }
    });

    $('#debiteur_type').change(function() {
        if ($('#debiteur_type').val() == 'zakelijk') {
            $('.zakelijk').show('slow');
        }
        else
        {
            $('.zakelijk').hide('slow');
        }
    });

    $('.eigen_voorwaarden').change(function() {
        if ($(this).val() == 'Ja')
        {
            $('.eigen_voorwaarden_upload').show('slow');
        }
        else
        {
            $('.eigen_voorwaarden_upload').hide('slow');
        }
    });

    $('.add_extra_phonenumbers').click(function(e) {
        e.preventDefault();
        var content = $('.extra_phonenumbers').html();
        var box = $('.extra_phonenumbers_box');
        box.after(content);
    });

    $('.add_extra_email').click(function(e) {
        e.preventDefault();
        var content = $('.extra_email').html();
        var box = $('.extra_email_box');
        box.after(content);
    });

    $('.add_extra_factuur').click(function(e) {
        e.preventDefault();
        var content = $('.extra_factuur').html();
        var box = $('.extra_factuur_box');
        box.after(content);
    });

    $('.factuur_totstandkoming').on('change', function() {
        if (this.value == 'anders')
        {
            $('.factuur_totstandkoming_anders').show('slow');
        }
        else
        {
            $('.factuur_totstandkoming_anders').hide('slow');
        }
    });

    var current_fs, next_fs, previous_fs, recaptcha_active, error_recaptcha; //fieldsets
    var opacity;
    var radioCheck;
    var current = 1;
    var steps = $("fieldset").length;

    $("fieldset .next").click(function(e){

        console.log('Next clicked');
        current_fs = $(this).parent();
        next_fs = $(this).parent().next();

        console.log('Check recaptcha');
        recaptcha_active = $(this).parent().data('recaptcha');

        console.log('Recpatcha check passed');

        /** check required fields */
        var required = $('input,textarea,select').filter('[required]:visible');
        var allRequired = false;

        required.each(function(){
            if($(this).val() === ''){

                allRequired = true;
                $(this).addClass('error');
                console.log('Name: ' + $(this).attr('name'));
            }
            else
            {
                /**
                 * EXTRA CODE FOR NPS
                 */
                if ($(this).attr('name') == 'waardering')
                {
                    console.log('Waardering! Value: ' + $(this).is(':checked'));
                    if ($(this).is(':checked') && $(this).val() <= 6)
                    {
                        $('.result-detractors').show();
                        $('.result-neutrals').hide();
                        $('.result-promoters').hide();
                    }
                    else if ($(this).is(':checked') && ($(this).val() == 7 || $(this).val() == 8))
                    {
                        $('.result-neutrals').show();
                        $('.result-detractors').hide();
                        $('.result-promoters').hide();
                    }
                    else if ($(this).is(':checked') && $(this).val() > 8)
                    {
                        $('.result-promoters').show();
                        $('.result-detractors').hide();
                        $('.result-neutrals').hide();
                    }
                }


                if ($(this).attr('type') === 'email' && !isEmail($(this).val()))
                {
                    allRequired = true;
                    $('label span').show();
                    $(this).addClass('error');
                    console.log('Type email is not a valid email address');
                }
                else if ($(this).attr('type') === 'checkbox' && !$(this).is(':checked'))
                {
                    allRequired = true;
                    $(this).parent().find('label').addClass('error');
                }
                else if ($(this).attr('type') === 'radio')
                {
                    $(current_fs).find('input:radio').each(function(){
                        console.log('Checking radio button');
                        if ( $(this).is(':checked') ) {
                            radioCheck = true;
                            console.log('Radio checked? Yes!');
                        }
                        else
                        {
                            console.log('Radio checked? No!');
                        }
                    });

                    if (radioCheck)
                    {
                        radioCheck = false;
                    }
                    else
                    {
                        allRequired = true;
                    }
                }
                else
                {
                    $(this).removeClass('error');
                    $('label span').hide();
                }
            }
        });

        /** check recaptcha **/
        if (recaptcha_active == 1 && !recaptchachecked)
        {
            console.log('Recaptcha gives an error');
            error_recaptcha = 1;
        }
        else
        {
            error_recaptcha = false;
        }

        /** report error back to user */
        if(allRequired || error_recaptcha){
            console.log('allRequried of recaptcha error');
            $('.error_reporting').addClass('active');

            if (error_recaptcha) {
                $('.recaptcha_error').show();
            }

            e.preventDefault();
            return;
        }
        else
        {
            if ($(this).attr('name') == 'financial-test') {
                hintnr = $(this).parent().data('number')+1;
                console.log(hintnr);
                $('.hint').hide();
                $('.hint' + hintnr).fadeToggle();
            }

            $('.error_reporting').removeClass('active');
            $('label span').hide();
        }

        if ($(this).attr('name') != 'financial-test') {
            $('html, body').animate({scrollTop: '0px'}, 500);
        }

        //Add Class Active
        $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

        //show the next fieldset
        next_fs.show();
        //hide the current fieldset with style
        current_fs.animate({opacity: 0}, {
            step: function(now) {
                // for making fielset appear animation
                opacity = 1 - now;

                current_fs.css({
                    'display': 'none',
                    'position': 'relative'
                });
                next_fs.css({'opacity': opacity});
            },
            duration: 500
        });
    });

    $("fieldset .previous").click(function(){

        if ($(this).attr('name') == 'financial-test') {
            hintnr = $(this).parent().data('number') - 1;
            $('.hint').hide();
            $('.hint' + hintnr).toggle();
        }

        current_fs = $(this).parent();
        previous_fs = $(this).parent().prev();

        //Remove class active
        $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

        //show the previous fieldset
        previous_fs.show();

        //hide the current fieldset with style
        current_fs.animate({opacity: 0}, {
            step: function(now) {
                // for making fielset appear animation
                opacity = 1 - now;

                current_fs.css({
                    'display': 'none',
                    'position': 'relative'
                });
                previous_fs.css({'opacity': opacity});
            },
            duration: 500
        });

        if ($(this).attr('name') != 'financial-test') {
            $('html, body').animate({scrollTop: '0px'}, 500);
        }
    });

    /**
     * Initialize
     */
    _this.init = function()
    {
        /**
         *
         * Ajax calls forms
         *
         */

        $('.feedback-form').submit(function() {
            var data = $(this).serialize();

            $.ajax({
                url: $(this).attr('action'),
                type: 'POST',
                data: data,
            }).done(function() {
                console.log('success');
                $('.feedback-form').hide('fadeOut', function() {
                    $('.ajax-form-response-feedback').show('fadeIn', function() {
                        setTimeout(function() {
                            $('#feedback').removeClass('opened');
                        }, 2000);
                    });
                });
            });

            return false;
        });

        $('.ajax-form').submit(function(e) {
            e.preventDefault();

            var formname = $(this).data('formname');

            console.log('start ajax call form');
            var domform = $(this);
            var data = new FormData(this);
            console.log(data);

            var response_class;
            var hide;

            $.ajax({
                url: $(this).attr('action'),
                type: 'POST',
                data: data,
                processData: false,
                contentType: false,
            }).done(function(response) {
                console.log('success');

                /*
                if (formname)
                {
                    console.log(formname);
                    if (formname == 'incassoabonnement')
                    {
                        gtag('event', 'conversion', {'send_to': 'AW-589861068/6-2CCLjAoeYBEMyhopkC'});
                        console.log('adwords logged');
                    }
                    else if (formname == 'incasso')
                    {
                        gtag('event', 'conversion', {'send_to': 'AW-589861068/pSVdCPGsreYBEMyhopkC'});
                    }
                }
                */

                hide = domform.data('hide');
                if (hide) {
                    $('.' + hide).fadeOut();
                }

                response_class = domform.data('response');
                $('.' + response_class).html(response);
                $('.' + response_class).fadeIn();
            });

            return false;
        });

        $('a[rel="external"]').attr('target', '_blank');

        $('.hamburger').on('click', function() {
            $(this).parent().parent().parent().parent().toggleClass('open');
            $(this).toggleClass('open');
        });

        /**
         * Notice box
         */
        setTimeout(function() {
            $('#notice').addClass('opened');
        }, 500);


        $('#notice .box .close').on('click', function() {
            $(this).parent().parent().toggleClass('closed').removeClass('opened');
        });

        $('#notice .box .lable:not(.opened)').on('click', function() {
            $(this).parent().parent().addClass('opened').removeClass('closed');
        });

        /**
         * Feedback box
         */
        $('#feedback .box .close').on('click', function() {
            $(this).parent().parent().toggleClass('closed').removeClass('opened');
        });

        $('#feedback .box .lable:not(.opened)').on('click', function() {
            $(this).parent().parent().addClass('opened').removeClass('closed');
        });

        /**
         * Change background on hover DEBTOR or BUSINESS
         */

        $('#section-choice .company').hover(function() {
            $('body').removeClass('debtor');
        });

        $('#section-choice .debtor').hover(function() {
            $('body').addClass('debtor');
        });

        /**
         * Logo carousel BUSINESS
         */
        $('.reference').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            dots: false,
            prevArrow: true,
            nextArrow: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });

        /**
         * Logo carousel BUSINESS
         */
        $('.testimonials').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            dots: false,
            prevArrow: true,
            nextArrow: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });

        /**
         * Logo carousel BUSINESS
         */
        $('.news-headlines').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            dots: true,
            prevArrow: true,
            nextArrow: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });

        $('button.slick-previous').click(function(){
            $(".reference").slick('slickPrev');
            $(".testimonials").slick('slickPrev');
        });

        $('button.slick-next').click(function(){
            $(".reference").slick('slickNext');
            $(".testimonials").slick('slickNext');

        });

        var acc = document.getElementsByClassName("question");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.display === "block") {
                    panel.style.display = "none";
                } else {
                    panel.style.display = "block";
                }
            });
        }
    };


    /**
     *  If body is not loaded, init
     */
    if (!_body.hasClass('loaded'))
    {
        _this.init();
    }
});